export default __webpack_public_path__ + "static/media/left.e74de3ec.svg";